<template lang="pug">
  v-app(style='background: #FFFFFF !important;')
    v-container(fluid, grid-list-xl)
      v-content
        v-layout(row, justify-center)
          v-flex(xs12, sm12, md10, lg9, text-xs-center)
            v-card(flat)
              v-card-text.label16tt.withDivider
                | LECCIÓN: ELIGE TU CRÉDITO HIPOTECARIO
              v-spacer.pa-5
              .titulo60Book.pa-0.ma-0
                b Bienvenido(a) a la Lección:
              .titulo60Book.pa-0.ma-0.mt-3
                | Elige tu Crédito Hipotecario
              v-card-text.parrafoDestacado18.py-5
                b ¿Tú ya cursaste la Lección Descubriendo el Crédito Hipotecario?
              v-btn.btn(justify-space-between, type='button', color='secondary', @click.prevent="nextPage('page2-1')")
                | Sí
              v-btn.btn(justify-space-between, type='button', color='secondary', @click.prevent="nextPage('page1-1')")
                | No
            l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      progress: false
    }
  },
  methods: {
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    }
  }
};
</script>
